module.exports = __webpack_public_path__ + "image/bg_logo.png";